var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCohortremoveicon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.5C0 1.39543 0.895431 0.5 2 0.5H13C14.1046 0.5 15 1.39543 15 2.5V13.5C15 14.6046 14.1046 15.5 13 15.5H2C0.89543 15.5 0 14.6046 0 13.5V2.5Z",
    fill: "#03C4DE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 7.5,
    width: 8,
    height: 1,
    rx: 0.5,
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCohortremoveicon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cohortremoveicon.d329e499370b70eefd6b2326a0f047ba.svg";